import { FC } from 'react';
import { Tooltip, Typography } from '@getsynapse/design-system';

interface TruncatedDependencyTitleProps {
  displayId: string;
  name: string;
  characterLimit?: number;
}

const DependencyTitle: FC<{ title: string; className?: string }> = ({
  title,
  className = 'text-primary',
}) => (
  <Typography variant='label' className={className}>
    {title}
  </Typography>
);

const TruncatedDependencyTitle: FC<TruncatedDependencyTitleProps> = ({
  name,
  displayId,
  characterLimit = 36,
}) => {
  const shouldTruncateName = name.length > characterLimit;

  if (shouldTruncateName) {
    const truncatedName = `${name.slice(0, characterLimit)}...`;
    return (
      <Tooltip
        openMode='hover2'
        timeout={0}
        usePortal
        showPopper
        trigger={
          <div>
            <DependencyTitle title={`${displayId} - ${truncatedName}`} />
          </div>
        }
        contentProps={{
          className: 'bg-neutral-darker z-50 px-2 py-1',
        }}
      >
        <DependencyTitle
          title={`${displayId} - ${name}`}
          className='text-neutral-white'
        />
      </Tooltip>
    );
  }

  return (
    <DependencyTitle
      title={`${displayId} - ${name}`}
      className='text-primary'
    />
  );
};

export default TruncatedDependencyTitle;
